module.exports = __webpack_public_path__ + "static/media/selfie_img_form.c3695f74.png";